import { Input, InputProps, InputRef } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";
import React, { forwardRef } from "react";
import { getSharedPillStyles } from "pages/media/projects/helpers/helper";
import { LoadingOutlined, EnterOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { radius } from "@libertify/ui";

interface EditableTagInputProps extends InputProps {
  onConfirm: () => void;
  onBlur?: () => void;
  theme: ReturnType<typeof useAntTheme>["theme"];
  loading?: boolean;
  teal?: boolean;
}

const TEAL_STYLE: React.CSSProperties = {
  border: "1px solid #ccfbf1",
  background: "#f0fdfb",
  color: "#0d9488",
  borderRadius: radius.pill,
  padding: "0 10px",
  height: 30,
  fontSize: "12px",
  fontWeight: 500,
  margin: 0,
};

export const EditableTagInput = forwardRef<InputRef, EditableTagInputProps>(
  ({ onConfirm, onBlur, theme, loading, teal, ...props }, ref) => {
    const sharedStyles = teal
      ? TEAL_STYLE
      : getSharedPillStyles(theme, {
          margin: 0,
          borderRadius: theme.borderRadiusLG,
        });

    const inputColor = teal ? "#0d9488" : theme.colorTextDescription;
    const suffixColor = teal ? "#0d9488" : theme.colorTextDescription;

    return (
      <StyledInput
        ref={ref}
        size="small"
        style={sharedStyles}
        onPressEnter={onConfirm}
        onBlur={onBlur}
        styles={{
          input: {
            width: "fit-content",
            color: inputColor,
          },
          ...props.styles,
        }}
        suffix={
          <div style={{ color: suffixColor }}>
            {loading ? <LoadingOutlined spin /> : <EnterOutlined />}
          </div>
        }
        {...props}
      />
    );
  }
);

const StyledInput = styled(Input)`
  input::placeholder {
    color: ${({ theme }) => theme.colorTextDescription};
  }
`;

EditableTagInput.displayName = "EditableTagInput";
